module.exports = __webpack_public_path__ + "img/icon@2x(6).cd3fc504.png";